<template>
  <div style="text-align: center;">
    <van-nav-bar title="登录验证" left-text="" right-text="" left-arrow @click-left="back"></van-nav-bar>
    <img :src="face" style="margin: 50px,auto;width: 300px;height: 300px;" />
    
    <van-button @click="checkface" class="btn">人脸验证</van-button>
    
    <div>{{ tishi }}</div>
  
  </div>
</template>

<script>
export default {
  data() {
    return {
      face: require('../assets/img/person.png'),
      tishi: '请先进行人脸识别验证再进入系统'
    };
  },
  methods: {
    back() {
      console.log('back');
      this.$router.go(-1);
    },
    checkface() {
       localStorage.setItem('facecheck', 'false');
      let data = '';
      this.$jtp('openCameraFace', data, this.getFace);
    },
    getFace(res) {
      this.face = res;
      this.tishi = '验证中.....';
      let data = new FormData();

      data.append('img', this.face);
      let that = this;
      this.$ajax.post('/upfile', data).then(function(res) {
        that.checkfacebypath(res);
      });
    },
    facepass() {
      localStorage.setItem('facecheck', 'true');

      this.$router.push('/studentmain');
    },
    facefail() {
      this.$toast.fail('人脸验证未通过,再试');
      this.tishi = '人脸验证未通过,再试';
    },
    checkfacebypath(path) {
      this.tishi = '数据已上传，验证中....';
      console.log(path)
      this.facepass();
      // let that = this;
      // this.$ajax({
      //   url: '?imgpath=' + encodeURIComponent(path) ,
      //   baseURL: '/api1/',
      //   method: 'get'
      // }).then(function(res) {
      //   that.tishi = res;

      //   let user = JSON.parse(localStorage.getItem('user'));
      //   console.log(user);
      //   if (user.xh && res.indexOf(user.xh) != -1) {
      //     that.facepass();
      //   } else if (user.sfzjh != undefined && user.sfzjh != '' && res.indexOf(user.sfzjh) != -1) {
      //      that.facepass();
      //   } else {
      //     that.facefail();
      //   }
      // });
    }
  }
};
</script>

<style>
.btn {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  color: #fff;
  background-color: #ff962a;
}
</style>



// WEBPACK FOOTER //
// src/components/facecheck.vue